import { render, staticRenderFns } from "./taxes.vue?vue&type=template&id=6ceb360c&scoped=true&"
import script from "./taxes.ts?vue&type=script&lang=ts&"
export * from "./taxes.ts?vue&type=script&lang=ts&"
import style0 from "./taxes.scss?vue&type=style&index=0&id=6ceb360c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ceb360c",
  null
  
)

export default component.exports